import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService } from 'src/app/services/LoaderService';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit {
  color = 'primary';
  mode = 'indeterminate';
  value = 100;
  @Input() diameter = 50;

  loadingState$: Observable<boolean>;

  constructor(private loaderService: LoaderService) {}

  ngOnInit(): void {
    this.loadingState$ = this.loaderService.loadingState;
  }
}
